import type { MouseEvent, RefObject } from "react";

export function focusPanelTextField(
  e: MouseEvent<HTMLDivElement>,
  inputRef: RefObject<HTMLTextAreaElement | null>,
) {
  const t = e.target as HTMLElement;
  if (t.closest("textarea") || t.closest(".MuiOutlinedInput-root")) {
    return;
  }
  inputRef.current?.focus();
}
